import { useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { AuthShell } from "@/pages/Login";
import { API, formatApiError } from "@/lib/newsUtils";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Las contraseñas no coinciden.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/reset-password`, { token, password });
      localStorage.setItem("token", data.access_token);
      toast.success("Contraseña actualizada. ¡Bienvenido de nuevo!");
      window.location.href = "/";
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail, err.message));
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <AuthShell title="Enlace no válido" subtitle="Falta el token de restablecimiento.">
        <p className="text-sm text-muted-foreground">
          Solicita un nuevo enlace desde{" "}
          <Link to="/forgot-password" className="text-primary font-semibold hover:underline">recuperar contraseña</Link>.
        </p>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Nueva contraseña" subtitle="Elige una contraseña nueva para tu cuenta.">
      <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
        <div className="space-y-1.5">
          <Label htmlFor="password" className="text-xs uppercase tracking-wide font-semibold">Nueva contraseña</Label>
          <Input id="password" type="password" data-testid="reset-password" value={password}
            onChange={(e) => setPassword(e.target.value)} required placeholder="Mínimo 6 caracteres"
            className="rounded-none border-border h-11" />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="confirm" className="text-xs uppercase tracking-wide font-semibold">Repite la contraseña</Label>
          <Input id="confirm" type="password" data-testid="reset-confirm" value={confirm}
            onChange={(e) => setConfirm(e.target.value)} required className="rounded-none border-border h-11" />
        </div>
        {error && <p className="text-sm text-destructive" data-testid="reset-error">{error}</p>}
        <Button type="submit" data-testid="reset-submit" disabled={loading}
          className="rounded-none bg-primary hover:bg-blue-900 w-full h-11 gap-2">
          {loading && <Loader2 className="w-4 h-4 animate-spin" />}
          Guardar contraseña
        </Button>
      </form>
    </AuthShell>
  );
}
